import { uniqueArray } from '../../../utilities'

export type GroupType = APICustomFieldGroup['object_type']

export const createDefaults = <T>(val: T): Record<GroupType, T> => {
  return {
    'external-user': val,
    task: val,
    user: val
  }
}

export const formatData = (data: APICustomFieldGroup & Record<string, any>) => {
  const {
    id,
    object_type,
    type_id,
    title,
    description,
    order,
    field_ids = [],
    created_by,
    fields = []
  } = data

  const formatted: APICustomFieldGroup = {
    id,
    object_type,
    type_id,
    title,
    description: description ?? '',
    order,
    field_ids: uniqueArray(fields, field_ids) as string[],
    created_by
  }

  return formatted
}
